import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiPageableOutput } from '../../../../common/model/api-pageable.output';
import { ApiQuery } from '../../../../common/model/api.query';
import { NotificationOutput } from '../model/notification.output';

export interface FetchNotificationsInput {
	readonly offset: number;
	readonly chunckSize: number;
}

export interface FetchNotificationsParams {
	query: FetchNotificationsInput;
}

@Injectable({ providedIn: 'root' })
export class FetchNotificationsApiQuery extends ApiQuery<
	ApiPageableOutput<NotificationOutput>,
	FetchNotificationsParams
> {
	client = 'messaging';
	document = gql`
		query FetchNotifications($query: FetchNotificationsInput!) {
			fetchNotifications(input: $query) {
				elements {
					id
					type
					taskId
					documentId
					orgModuleId
					sourceUserId
					targetUserId
					contactsName
					updateTimestamp
					creationDateTime
					meeting {
						coachId
						endDate
						startDate
					}
				}
				totalElements
			}
		}
	`;
	method = 'fetchNotifications';
}
